import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axios';
import { fetchUserWithdashboard } from '../utils/auth';
import './Dashboard.css';
import Issues from '../components/Issues';
import QuickNavigation from '../components/QuickNavigation';

const Dashboard = () => {
  return (
    <div className="dashboard-parent-container">
      <div className="dashboard-container">
        <div style={{ fontSize:"30px" }}>
          Welcome to ShadowStream
        </div>
        <Issues />
        <QuickNavigation />
      </div>
    </div>
  );
};

export default Dashboard;
